import React from 'react';
import NftPreview from './NftPreview';

function CollectionGrid({ assets }) {
  return (
    <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-x-5 gap-y-8'>
      {assets.map((asset, index) => (
        <div key={index}>
          <NftPreview nft={asset} />
        </div>
      ))}
    </div>
  );
}

export default CollectionGrid;
